/* Antonio Amberes · Carat size simulator (standalone)
   Does NOT read or change product variants, price, URL or cart. It only draws a diamond to scale. */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';

  function $(s, r) { return (r || document).querySelector(s); }
  function svg(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function num(v, d) {
    if (v === null || v === undefined || v === '') return d;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? n : d;
  }
  function nums(str, count, defaults) {
    var a = String(str || '').split(/[\s,;]+/).map(function (x) { return num(x, NaN); }).filter(isFinite);
    return defaults.map(function (d, i) { return a[i] !== undefined ? a[i] : d; }).slice(0, count);
  }
  function lang() { return document.documentElement.lang || 'en'; }
  function fmt(n, min, max) {
    try { return n.toLocaleString(lang(), { minimumFractionDigits: min, maximumFractionDigits: max }); }
    catch (e) { return n.toFixed(max); }
  }
  var METAL = {
    yellow: { band: ['#b58836', '#e9ca7e'], dot: '#e3c373' },
    white:  { band: ['#9aa2ab', '#f2f4f7'], dot: '#d9dde2' },
    rose:   { band: ['#b76e5a', '#f0b9a6'], dot: '#e3a493' }
  };

  var imgCache = {};
  function loadImage(url) {
    if (!imgCache[url]) {
      imgCache[url] = new Promise(function (resolve, reject) {
        var im = new Image();
        im.onload = function () { resolve({ w: im.naturalWidth, h: im.naturalHeight }); };
        im.onerror = reject;
        im.src = url;
      });
    }
    return imgCache[url];
  }

  function Sim(root) {
    this.root = root;
    this.cfg = JSON.parse($('[data-aa-config]', root).textContent);
    this.svg = $('[data-aa-svg]', root);
    this.range = $('[data-aa-range]', root);
    this.ticks = $('[data-aa-ticks]', root);
    this.weightEl = $('[data-aa-weight]', root);
    this.mmEl = $('[data-aa-mm]', root);
    this.labelEl = $('[data-aa-label]', root);
    this.goldEl = $('[data-aa-gold]', root);
    this.cur = { w: 0, h: 0 };
    this.raf = null;
    this.stoneUrl = null;
    this.stoneDims = null;

    var cfg = this.cfg, seen = {};
    this.stops = String(cfg.carats || '').split(/[\s,;]+/).map(function (x) { return num(x, NaN); })
      .filter(function (x) { if (!(x > 0) || seen[x]) return false; seen[x] = 1; return true; })
      .sort(function (a, b) { return a - b; });
    if (!this.stops.length) this.stops = [0.3, 0.5, 0.7, 1, 1.5, 2, 3, 4, 5, 6, 7];

    this.table = {};
    var table = this.table;
    String(cfg.sizes || '').split(/[,;\n]+/).forEach(function (pair) {
      var m = /^\s*([\d.,]+)\s*=\s*([\d.,]+)\s*$/.exec(pair);
      if (m) table[num(m[1], 0).toFixed(3)] = num(m[2], NaN);
    });

    var imgs = cfg.images || {};
    this.metals = ['yellow', 'white', 'rose'].filter(function (k) { return !!imgs[k]; });
    this.metal = this.metals[0] || 'yellow';

    this.buildScene();
    this.buildGold();
    this.buildTicks();
    this.range.min = 0;
    this.range.max = Math.max(0, this.stops.length - 1);
    this.range.disabled = this.stops.length < 2;

    var start = num(cfg.startCarat, 1), idx = 0, best = Infinity, i;
    for (i = 0; i < this.stops.length; i++) {
      var d = Math.abs(this.stops[i] - start);
      if (d < best) { best = d; idx = i; }
    }
    var self = this;
    this.range.addEventListener('input', function () { self.show(parseInt(self.range.value, 10), true); });
    this.range.value = idx;
    this.show(idx, false);
  }

  Sim.prototype.sizeFor = function (ct) {
    var c = this.cfg, t = this.table[ct.toFixed(3)];
    var refCt = num(c.refCarat, 1), refW = num(c.refWidthMm, 6.5), refH = num(c.refHeightMm, refW);
    var k = Math.cbrt(ct / refCt);
    if (isFinite(t)) return { w: t, h: t * (refH / refW), exact: true };
    return { w: refW * k, h: refH * k, exact: false };
  };

  Sim.prototype.buildScene = function () {
    var s = this.cfg.scene, root = this.svg;
    var view = nums(s.view, 4, [0, 0, s.handWidth || 1024, s.handHeight || 1536]);
    var ring = nums(s.ring, 3, [600, 518, 8]);
    var ruler = nums(s.ruler, 2, [815, 445]);
    this.ppm = num(s.coinPx, 122) / num(s.coinMm, 23.25);   // image pixels per millimetre
    this.bandMm = num(this.cfg.bandMm, 1.8);

    root.setAttribute('viewBox', view.join(' '));
    root.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    if (s.handImage) svg('image', { href: s.handImage, x: 0, y: 0, width: s.handWidth || 1024, height: s.handHeight || 1536 }, root);

    this.ring = svg('g', { transform: 'translate(' + ring[0] + ' ' + ring[1] + ') rotate(' + ring[2] + ')' }, root);
    this.bandA = svg('path', { fill: 'none', 'stroke-linecap': 'butt' }, this.ring);
    this.bandB = svg('path', { fill: 'none', 'stroke-linecap': 'butt' }, this.ring);
    this.pave = svg('g', { fill: '#f7fbff', stroke: '#c4ced9', 'stroke-width': '.7' }, this.ring);
    if (s.showPave) for (var i = -6; i <= 6; i++) svg('circle', { cx: i * 7.5, cy: 3, r: 2.4 }, this.pave);
    this.stoneG = svg('g', {}, this.ring);
    this.stoneImg = svg('image', { x: 0, y: 0, width: 1, height: 1, opacity: 0 }, this.stoneG);
    if (s.blend === 'multiply') this.stoneG.style.mixBlendMode = 'multiply';

    var g = svg('g', { transform: 'translate(' + ruler[0] + ' ' + ruler[1] + ')', fill: '#333', stroke: '#333' }, root);
    var total = Math.round(num(s.rulerMm, 20));
    for (var m = 0; m <= total; m++) {
      var y = m * this.ppm;
      svg('line', { x1: 0, x2: m % 5 === 0 ? 17 : 9, y1: y, y2: y }, g);
      if (m % 5 === 0) {
        var t = svg('text', { x: 24, y: y + 4, stroke: 'none', 'font-size': 14 }, g);
        t.textContent = m;
      }
    }
    var u = svg('text', { x: 0, y: -12, stroke: 'none', 'font-size': 14 }, g);
    u.textContent = 'mm';
  };

  Sim.prototype.buildGold = function () {
    var self = this, cfg = this.cfg, labels = cfg.labels || {};
    this.goldEl.innerHTML = '';
    if (cfg.showGold === false || this.metals.length < 2) return;
    this.metals.forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aa-sim__gold-btn';
      b.setAttribute('data-metal', k);
      var dot = document.createElement('span');
      dot.className = 'aa-sim__gold-dot';
      dot.style.background = METAL[k].dot;
      b.appendChild(dot);
      b.appendChild(document.createTextNode(labels[k] || k));
      b.addEventListener('click', function () { self.metal = k; self.show(self.index, false); });
      self.goldEl.appendChild(b);
    });
  };

  Sim.prototype.buildTicks = function () {
    var self = this, n = this.stops.length, skip = n > 8 ? 2 : 1;
    this.ticks.innerHTML = '';
    this.stops.forEach(function (ct, i) {
      var t = document.createElement('span');
      t.className = 'aa-sim__tick' + (i % skip && i !== n - 1 ? ' aa-sim__tick--hidden' : '');
      t.textContent = fmt(ct, 0, 2) + ' ct';
      var p = n > 1 ? i / (n - 1) : 0;
      t.style.left = 'calc(var(--aa-thumb) / 2 + (100% - var(--aa-thumb)) * ' + p + ')';
      self.ticks.appendChild(t);
    });
  };

  Sim.prototype.render = function (w, h) {
    this.cur = { w: w, h: h };
    var d = this.stoneDims, c = this.cfg;
    var bandPx = this.bandMm * this.ppm;                     // constant: the ring never gets thicker
    var half = Math.max(50, (w * this.ppm) / 2 + 22);
    this.bandA.setAttribute('d', 'M' + (-half) + ' 0 Q0 8 ' + half + ' 0');
    this.bandA.setAttribute('stroke-width', bandPx);
    this.bandB.setAttribute('d', 'M' + (-half) + ' -1 Q0 7 ' + half + ' -1');
    this.bandB.setAttribute('stroke-width', bandPx * 0.67);
    if (!d) return;
    var pxW = num(c.stonePxWidth, d.w), pxH = num(c.stonePxHeight, pxW * (d.h / d.w));
    var uniform = !(c.stonePxWidth && c.stonePxHeight);
    var sx = (w * this.ppm) / pxW;
    var sy = uniform ? sx : (h * this.ppm) / pxH;           // prongs grow together with the stone
    this.stoneG.setAttribute('transform', 'scale(' + sx + ' ' + sy + ')');
  };

  Sim.prototype.animateTo = function (w, h) {
    var self = this, from = { w: this.cur.w || w, h: this.cur.h || h }, t0 = null, dur = 220;
    if (this.raf) cancelAnimationFrame(this.raf);
    if (!window.requestAnimationFrame || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || !this.cur.w) {
      return this.render(w, h);
    }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      self.render(from.w + (w - from.w) * e, from.h + (h - from.h) * e);
      if (p < 1) self.raf = requestAnimationFrame(step); else self.raf = null;
    }
    this.raf = requestAnimationFrame(step);
  };

  Sim.prototype.setStoneImage = function (url) {
    var self = this;
    if (!url || url === this.stoneUrl) return;
    this.stoneUrl = url;
    loadImage(url).then(function (d) {
      if (url !== self.stoneUrl) return;
      self.stoneDims = d;
      var ax = num(self.cfg.anchorX, 0.5), ay = num(self.cfg.anchorY, 0.5);
      self.stoneImg.setAttribute('href', url);
      self.stoneImg.setAttribute('x', -ax * d.w);
      self.stoneImg.setAttribute('y', -ay * d.h);
      self.stoneImg.setAttribute('width', d.w);
      self.stoneImg.setAttribute('height', d.h);
      self.stoneImg.setAttribute('opacity', 1);
      self.render(self.cur.w, self.cur.h);
      if (self.target) self.animateTo(self.target.w, self.target.h);
    }, function () {});
  };

  Sim.prototype.show = function (i, animate) {
    var ct = this.stops[i], n = this.stops.length;
    if (ct === undefined) return;
    this.index = i;
    var size = this.sizeFor(ct);
    this.target = size;
    this.weightEl.textContent = fmt(ct, 2, 2) + ' ct';
    this.mmEl.textContent = (size.exact ? '' : '≈ ') + fmt(size.w, 2, 2) + ' × ' + fmt(size.h, 2, 2) + ' mm';
    var labels = this.cfg.labels || {};
    var parts = [];
    if (this.cfg.shape) parts.push(this.cfg.shape);
    if (this.metals.length > 1 && this.cfg.showGold === false) parts.push(labels[this.metal] || this.metal);
    this.labelEl.textContent = parts.join(' · ');
    this.range.value = i;
    this.range.setAttribute('aria-valuetext', fmt(ct, 2, 2) + ' carat · ' + this.mmEl.textContent);
    this.range.style.setProperty('--aa-fill', (n > 1 ? (i / (n - 1)) * 100 : 0) + '%');
    var k, ticks = this.ticks.children;
    for (k = 0; k < ticks.length; k++) ticks[k].classList.toggle('aa-sim__tick--active', k === i);
    var btns = this.goldEl.children;
    for (k = 0; k < btns.length; k++) btns[k].setAttribute('aria-pressed', btns[k].getAttribute('data-metal') === this.metal ? 'true' : 'false');

    var col = (METAL[this.metal] || METAL.yellow).band;
    this.bandA.setAttribute('stroke', col[0]);
    this.bandB.setAttribute('stroke', col[1]);
    var imgs = this.cfg.images || {};
    this.setStoneImage(imgs[this.metal] || imgs.yellow || imgs.white || imgs.rose);
    if (animate) this.animateTo(size.w, size.h); else this.render(size.w, size.h);
  };

  function init(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-aa-sim]')).forEach(function (el) {
      if (el.__aaSim) return;
      try { el.__aaSim = new Sim(el); } catch (e) { if (window.console) console.error(e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
